import { render, staticRenderFns } from "./DYGoodBroadCaster.vue?vue&type=template&id=6a58844e&scoped=true"
import script from "./DYGoodBroadCaster.vue?vue&type=script&lang=js"
export * from "./DYGoodBroadCaster.vue?vue&type=script&lang=js"
import style0 from "./DYGoodBroadCaster.vue?vue&type=style&index=0&id=6a58844e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a58844e",
  null
  
)

export default component.exports